<template>
  <div class="page-content animate__animated animate__fadeIn">
    <div class="border-bottom" style="margin-top:0;">
      <!-- 顶部搜索框 -->
      <div>
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="系统类型">
            <el-select clearable v-model="queryParams.type" placeholder="请选择系统类型进行查询">
              <el-option label="系统" value="0"></el-option>
              <el-option label="1C" value="1"></el-option>
              <el-option label="2C" value="2"></el-option>
              <el-option label="3C" value="4"></el-option>
              <el-option label="4C" value="4"></el-option>
              <el-option label="5C" value="5"></el-option>
              <el-option label="6C" value="6"></el-option>
            </el-select>
          </el-form-item>

          <div class="btn-boxs">
            <div></div>
            <div>
              <el-button icon="el-icon-search" type="primary" @click="onSearch">查 询</el-button>
              <el-button icon="el-icon-refresh" @click="onReset">重 置</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="margin-top" style="margin-bottom:0;margin-top:15px">
      <!-- 表格组件 -->
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        border
        row-key="deptId"
        default-expand-all
        :tree-props="{children: 'children'}"
        highlight-current-row
        max-height="447"
        :header-cell-style="{ background: '#fafafa', color: '#606266', fontSize:'14px'}"
      >
        <!-- 多选 -->
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- 序号列 -->
        <el-table-column align="center" type="index" label="序号" width="50"></el-table-column>
        <!-- 动态生成其他列 -->
        <el-table-column
          align="center"
          v-for="tab in tableTitle"
          :key="tab.code"
          :label="tab.name"
          show-overflow-tooltip
          :width="tab.width"
        >
          <template slot-scope="scope">
            <!-- 针对 status 列的特殊处理 -->
            <span
              v-if="tab.code === 'state'"
              :style="scope.row.state === 0 ? { color: 'green'  } : { color: 'red'  }"
            >{{ scope.row.state === 0 ? '成功' : '失败' }}</span>
            <span v-else-if="tab.code === 'logTime'">
              <i class="el-icon-time"></i>
              <span style="margin-left:5px">{{ scope.row.logTime }}</span>
            </span>
            <span v-else-if="tab.code === 'type'">{{ typeMaping[scope.row.type] }}</span>
            <span v-else>{{ scope.row[tab.code] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <div>
        <Pagination
          background
          :total="pageParams.total"
          :page="pageParams.pageNum"
          :limit="pageParams.pageSize"
          @pagination="onChangePages"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { getSyslogList } from "@/api/admin-service/logs"
export default {
  components: {
    Pagination
  },
  data() {
    return {
      tableLoading: false,
      // 表格数据
      tableData: [],
      // 表格标题数组
      tableTitle: [
        { name: "系统类型", code: "type", width: "" },
        { name: "操作方法", code: "operateMethod", width: "" },
        { name: "操作模块", code: "module", width: "" },
        { name: "操作接口路径", code: "path", width: "" },
        { name: "日志时间", code: "logTime", width: "" },
        { name: "操作人名称", code: "logName", width: "" },
        { name: "操作状态", code: "state", width: "" }
      ],
      pageParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      queryParams: {
        operateType: "0",
        type: ""
      },
      typeMaping: {
        0: "系统",
        1: "1C",
        2: "2C",
        3: "3C",
        4: "4C",
        5: "5C",
        6: "6C"
      }
    };
  },
  mounted() {
    this.onGetDataList();
  },

  methods: {
    // 查
    onGetDataList() {
      this.tableLoading = true;
      getSyslogList({
        ...this.queryParams,
        ...this.pageParams
      })
        .then(res => {
          const { records, total } = res.data;
          this.tableData = records;
          this.pageParams.total = total;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    // 查询
    onSearch() {
      this.onGetDataList();
    },
    // 重置
    onReset() {
      this.pageParams.pageNum = 1;
      this.pageParams.pageSize = 10;
      this.queryParams.type = "";
      this.onSearch();
    },
    // 分页方法
    onChangePages(pageInfo) {
      this.pageParams.pageNum = pageInfo.page;
      this.pageParams.pageSize = pageInfo.limit;
      this.onGetDataList();
    }
  }
};
</script>
<style lang="less" scoped>
.form-item-width {
  width: 250px;
}

.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}
.margin-top {
  margin-top: -15px;
}
</style>
